import data from "./salaahtime.json";

class GetTimeTable {
  constructor() {
    //this.timetable = data;
  }
  prepareData() {
    //console.log("data ", data);
    let modifiedTable = JSON.parse(JSON.stringify(data));
    let summerTime = this.getDateOfLastSunday(3) - 1;
    let winterTimer = this.getDateOfLastSunday(10) - 1;
    let summerLength = modifiedTable["months"][2]["march"].length;
    let winterLength = modifiedTable["months"][9]["october"].length;
    //console.log("This table", modifiedTable["months"])
    for (let i = 0; i < modifiedTable["months"].length; i++) {
      if (i === 2) {
        while (summerTime < summerLength) {
          //console.log("Summer time fajr " + summerTime + ': ' + modifiedTable['months'][2]['march'][summerTime]['fajr']['hour']);
          //console.log("Summer time sunrise " + summerTime + ': ' +modifiedTable['months'][2]['march'][summerTime]['sunrise']['hour']);
          //console.log("Summer time zuhr " + summerTime + ': ' +modifiedTable['months'][2]['march'][summerTime]['zuhr']['hour']);
          //console.log("Summer time asr " + summerTime + ': ' +modifiedTable['months'][2]['march'][summerTime]['asr']['hour']);
          //console.log("Summer time magrib " + summerTime + ': ' +modifiedTable['months'][2]['march'][summerTime]['magrib']['hour']);
          //console.log("Summer time isha " + summerTime + ': ' +modifiedTable['months'][2]['march'][summerTime]['isha']['hour']);
          modifiedTable["months"][2]["march"][summerTime]["fajr"]["hour"] =
            modifiedTable["months"][2]["march"][summerTime]["fajr"]["hour"] + 1;
          modifiedTable["months"][2]["march"][summerTime]["sunrise"]["hour"] =
            modifiedTable["months"][2]["march"][summerTime]["sunrise"]["hour"] +
            1;
          modifiedTable["months"][2]["march"][summerTime]["zuhr"]["hour"] =
            modifiedTable["months"][2]["march"][summerTime]["zuhr"]["hour"] + 1;
          modifiedTable["months"][2]["march"][summerTime]["asr"]["hour"] =
            modifiedTable["months"][2]["march"][summerTime]["asr"]["hour"] + 1;
          modifiedTable["months"][2]["march"][summerTime]["magrib"]["hour"] =
            modifiedTable["months"][2]["march"][summerTime]["magrib"]["hour"] +
            1;
          modifiedTable["months"][2]["march"][summerTime]["isha"]["hour"] =
            modifiedTable["months"][2]["march"][summerTime]["isha"]["hour"] + 1;

          //console.log("-------------------------------------------------------------")
          //console.log("Summer time fajr " + summerTime + ': ' + modifiedTable['months'][2]['march'][summerTime]['fajr']['hour']);
          //console.log("Summer time sunrise " + summerTime + ': ' +modifiedTable['months'][2]['march'][summerTime]['sunrise']['hour']);
          //console.log("Summer time zuhr " + summerTime + ': ' +modifiedTable['months'][2]['march'][summerTime]['zuhr']['hour']);
          //console.log("Summer time asr " + summerTime + ': ' +modifiedTable['months'][2]['march'][summerTime]['asr']['hour']);
          //console.log("Summer time magrib " + summerTime + ': ' +modifiedTable['months'][2]['march'][summerTime]['magrib']['hour']);
          //console.log("Summer time isha " + summerTime + ': ' +modifiedTable['months'][2]['march'][summerTime]['isha']['hour']);

          //console.log('Summertimer: ' + summerTime + ' times march ' + this.timetable['months'][2]['march'][summerTime]['sunrise']);
          summerTime++;
        }
      }

      if (i === 9) {
        while (winterTimer < winterLength) {
          //console.log("**********************");
          //console.log("wintertime " + winterTimer + ": " +modifiedTable['months'][9]['october'][winterTimer]['fajr']['hour']);
          //console.log("wintertime " + winterTimer + ": " +modifiedTable['months'][9]['october'][winterTimer]['sunrise']['hour']);
          //console.log("wintertime " + winterTimer + ": " +modifiedTable['months'][9]['october'][winterTimer]['zuhr']['hour']);
          //console.log("wintertime " + winterTimer + ": " +modifiedTable['months'][9]['october'][winterTimer]['asr']['hour']);
          //console.log("wintertime " + winterTimer + ": " +modifiedTable['months'][9]['october'][winterTimer]['magrib']['hour']);
          //console.log("wintertime " + winterTimer + ": " +modifiedTable['months'][9]['october'][winterTimer]['isha']['hour'])
          //console.log("**********************");
          modifiedTable["months"][9]["october"][winterTimer]["fajr"]["hour"] =
            modifiedTable["months"][9]["october"][winterTimer]["fajr"]["hour"] -
            1;
          modifiedTable["months"][9]["october"][winterTimer]["sunrise"][
            "hour"
          ] =
            modifiedTable["months"][9]["october"][winterTimer]["sunrise"][
              "hour"
            ] - 1;
          modifiedTable["months"][9]["october"][winterTimer]["zuhr"]["hour"] =
            modifiedTable["months"][9]["october"][winterTimer]["zuhr"]["hour"] -
            1;
          modifiedTable["months"][9]["october"][winterTimer]["asr"]["hour"] =
            modifiedTable["months"][9]["october"][winterTimer]["asr"]["hour"] -
            1;
          modifiedTable["months"][9]["october"][winterTimer]["magrib"]["hour"] =
            modifiedTable["months"][9]["october"][winterTimer]["magrib"][
              "hour"
            ] - 1;
          modifiedTable["months"][9]["october"][winterTimer]["isha"]["hour"] =
            modifiedTable["months"][9]["october"][winterTimer]["isha"]["hour"] -
            1;
          //console.log("**********************");
          //console.log("wintertime " + winterTimer + ": " +modifiedTable['months'][9]['october'][winterTimer]['fajr']['hour']);
          //console.log("wintertime " + winterTimer + ": " +modifiedTable['months'][9]['october'][winterTimer]['sunrise']['hour']);
          //console.log("wintertime " + winterTimer + ": " +modifiedTable['months'][9]['october'][winterTimer]['zuhr']['hour']);
          //console.log("wintertime " + winterTimer + ": " +modifiedTable['months'][9]['october'][winterTimer]['asr']['hour']);
          //console.log("wintertime " + winterTimer + ": " +modifiedTable['months'][9]['october'][winterTimer]['magrib']['hour']);
          //console.log("wintertime " + winterTimer + ": " +modifiedTable['months'][9]['october'][winterTimer]['isha']['hour'])

          //console.log('WinterTimer: ' + winterTimer +  'times october' + this.timetable['months'][9]['october'][winterTimer]['isha']);
          winterTimer++;
        }
      }
    }

    //console.log("modified data", modifiedTable["months"]);
    return modifiedTable;
  }
  getData() {
    return this.prepareData();
  }
  getByDay(day, month) {
    const today = day;
    const thisMonth = month;
    const monthData = this.getMonthlyData(thisMonth);
    let todayObj = {};
    for (let t of monthData) {
      if (t["id"] === today) {
        todayObj = monthData[today - 1];
      }
    }

    return todayObj;
  }
  getMonthlyData(month) {
    let monthlyData = [];
    const currentMonth = month;
    const monthArray = [
      "january",
      "february",
      "march",
      "april",
      "may",
      "june",
      "july",
      "august",
      "september",
      "october",
      "november",
      "december",
    ];
    for (let m of this.getData()["months"]) {
      if (m["id"] === currentMonth) {
        monthlyData = [...m[monthArray[currentMonth - 1]]];
      }
    }
    //this.getData()["months"][0]["january"];
    return monthlyData;
  }

  getDateOfLastSunday(month) {
    let currentDate = new Date();
    let year = currentDate.getFullYear();
    let sundays = [];

    let lastSunday = null;

    for (let i = 1; i <= 31; i++) {
      let calculatedDate = new Date(
        `${year}-${month < 10 ? "0" + month : month}-${
          i < 10 ? "0" + i : i
        }T00:00:00`
      );
      if (calculatedDate.getDay() === 0) {
        sundays.push(calculatedDate.getDate());
      }
    }

    if (sundays) {
      lastSunday = Math.max(...sundays);
    }

    return lastSunday;
  }
}

export { GetTimeTable as default };
